import { useFragment, graphql } from 'react-relay';

import { useOriginalListPrice_item$key } from './__generated__/useOriginalListPrice_item.graphql';

const itemFragment = graphql`
    fragment useOriginalListPrice_item on Item
    @argumentDefinitions(page: { type: "PageDisplayEnum", defaultValue: pdp }) {
        originalDisplayPrice: displayPrice(page: $page) {
            originalConvertedAmountList {
                amount
                currency
            }
        }
        pricing {
            retailPrice {
                convertedAmountList {
                    amount
                    currency
                }
            }
        }
    }
`;

type Props = {
    item: useOriginalListPrice_item$key | null;
    currency: string;
};

export const useOriginalListPrice = ({ item: itemRef, currency }: Props): number | null => {
    const item = useFragment(itemFragment, itemRef);
    const retailPrice = item?.pricing?.retailPrice;

    const originalConvertedAmountList =
        item?.originalDisplayPrice?.[0]?.originalConvertedAmountList ||
        retailPrice?.convertedAmountList;
    const originalListPriceByCurrency = originalConvertedAmountList?.find(
        convertedAmount => convertedAmount?.currency === currency
    );

    if (!originalListPriceByCurrency?.amount) {
        return null;
    }

    const originalListPrice = Math.floor(originalListPriceByCurrency.amount);

    return originalListPrice;
};
